import { render, staticRenderFns } from "./InvoiceTax.vue?vue&type=template&id=7621f8d3&"
import script from "./InvoiceTax.vue?vue&type=script&lang=js&"
export * from "./InvoiceTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7621f8d3')) {
      api.createRecord('7621f8d3', component.options)
    } else {
      api.reload('7621f8d3', component.options)
    }
    module.hot.accept("./InvoiceTax.vue?vue&type=template&id=7621f8d3&", function () {
      api.rerender('7621f8d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices-active/InvoiceTax.vue"
export default component.exports